var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartbeat1 = function SvgIconHeartbeat1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n        fill-rule: evenodd;\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.66,
    y1: 70.81,
    x2: 82.19,
    y2: 17.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_441042592",
    "data-name": 441042592
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.87,87.09h-.29c-1.11-.12-1.99-1.05-2.05-2.23l-2.81-54.66-6.85,25.72c-.29,1-1.23,1.7-2.28,1.7H2.34c-1.29,0-2.34-1.05-2.34-2.34s1.05-2.34,2.34-2.34h12.48L25.07,14.68c.29-1.11,1.35-1.87,2.52-1.76s2.05,1.05,2.11,2.23l2.75,54.72,4.34-16.17c.29-1,1.23-1.7,2.28-1.7h5.8l4.04-14.88c.29-1.05,1.23-1.76,2.28-1.76,1.11.06,1.99.82,2.23,1.87l5.16,23.67,5.21-13.83c.35-.94,1.23-1.52,2.23-1.52h31.63c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.34-2.34,2.34h-30.05l-7.44,19.74c-.35,1-1.35,1.58-2.34,1.52-1.05-.12-1.93-.82-2.17-1.87l-4.75-22.03-1.99,7.32c-.29,1-1.17,1.76-2.23,1.76h-5.86l-7.73,28.71c-.23,1-1.17,1.7-2.23,1.7Z"
  })))));
};
export default SvgIconHeartbeat1;